window.$ = jQuery